<div>
    <div class=" dcp-custom-form dcp p-2">
        <div class="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
            <h2 class="mb-0">Address Mismatch Confirmation</h2>
            <div class="btn-light btn-position" (click)="!isLoading && closeModal()" [class.disabled]="isLoading"> <span
                    class="mat-icon material-icons ">close</span>
            </div>
        </div>
    </div>

    <div class="dcp-panel">
        <div class="dcp-panel-header purple">
            <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true"
                data-mat-icon-type="font">info_outlined_icon </mat-icon>
            <h3 class="mb-0">Please select the addresses order should be processed with</h3>
        </div>
        <div class="dcp-panel-content">
            <p class="mb-0">Address mismatch detected. Select the correct shipping address or update details to proceed.
            </p>
        </div>
    </div>

    <div class="mismatch-popup dcp">
        <div class="d-flex justify-content-between align-items-center mb-3 heading-bar">
            <h5 class="fw-bold mb-0">Address Mismatch Conflicts</h5>
            <span><strong>{{ selectedIndex + 1 }}/{{ dataList.length }}</strong></span>
        </div>

        <div class="row">
            <!-- Sidebar -->
            <div class="col-md-2 sidebar">
                <div class="list-group">
                    <div class="list-group-item"><strong>Orders for Patients</strong></div>
                    <a *ngFor="let item of dataList; let i = index" href="javascript:void(0)"
                        class="d-flex justify-content-between align-items-center list-group-item list-group-item-action"
                        [ngClass]="{ 'active': i == selectedIndex }" (click)="selectPatient(i)">
                        <!-- disables clicks -->
                        {{ item.userInfo.fullName }}
                        <mat-icon *ngIf="reviewStatus[i]" class="mat-icon notranslate material-icons mat-ligature-font"
                            [ngClass]="{ 'success': reviewStatus[i] == 'success', 'warning': reviewStatus[i] == 'warning' }">
                            {{ reviewStatus[i] == 'success' ? 'check_circle' : 'error' }}
                        </mat-icon>
                    </a>
                </div>
            </div>

            <!-- Main Content -->
            <div class="col-md-10" *ngIf="dataList[selectedIndex] as selected">
                <div class="dcp-panel">
                    <div class="dcp-panel-header border-bottom d-block">
                        <div class="row">
                            <div class="col-md-6">
                                <h3 class="mb-0">Kroll Addresses</h3>
                            </div>
                            <div class="col-md-6">
                                <h3 class="mb-0">Patient App Addresses</h3>
                            </div>
                        </div>

                    </div>
                    <div class="dcp-panel-content">
                        <div class="row">
                            <!-- Kroll addrress -->
                            <div class="col-md-6">
                                <div class="form-group position-relative mb-3 overflow-x-auto">
                                    <div class="custom-control custom-radio custom-radio-group-outer mismatch-radio">
                                        <input type="radio" name="address" [id]="'kroll-' + selected.salesOrderID"
                                            class="custom-control-input"
                                            [checked]="selectedAddress == selected.krollAddress"
                                            (change)="onSelectAddress(selected.krollAddress)" [disabled]="isLoading">
                                        <label class="custom-control-label custom-radio-group overflow-hidden"
                                            [for]="'kroll-' + selected.salesOrderID">
                                            <h5 class="pe-5">Kroll ID Address</h5>
                                            <h5 class="pe-5">{{ selected.krollAddress?.address }}</h5>
                                            <div class="icon-bedge-outer justify-content-end">
                                                <div class="icon-right" [class.disabled]="isKrollRefreshing"
                                                    style="cursor: pointer;"
                                                    (click)="!isKrollRefreshing && refreshKrollAddr({ order_id: selected.salesOrderID, address_id: selected.krollAddress.id, user_id: selected.userInfo.user_id })">
                                                    <mat-icon role="img"
                                                        class="mat-icon notranslate material-icons mat-icon-no-color me-1"
                                                        aria-hidden="true"
                                                        data-mat-icon-type="font">refresh_outlined_icon</mat-icon>
                                                    {{isKrollRefreshing ? 'Refreshing...' : 'Refresh'}}
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- User Addresses -->
                            <div class="col-md-6">
                                <div *ngFor="let address of selected.userAddress; let j = index"
                                    class="form-group position-relative overflow-x-auto">
                                    <div class="custom-control custom-radio custom-radio-group-outer mismatch-radio">
                                        <input type="radio" name="userAddress{{ selected.salesOrderID }}"
                                            [id]="'user-' + address.id" class="custom-control-input"
                                            [checked]="selectedAddress == address.userAddress"
                                            (change)="onSelectAddress(address.userAddress)" [disabled]="isLoading">
                                        <label class="custom-control-label custom-radio-group overflow-hidden"
                                            [for]="'user-' + address.id">
                                            <h5 class="pe-5">{{ address.userAddress }}</h5>
                                            <div class="icon-bedge-outer">
                                                <div *ngIf="address.isDefault == 1" class="default-address-badge">
                                                    Default Address</div>
                                                <button class="icon-right btn p-0 border-0 bg-transparent"
                                                    [matTooltip]="'Copy success'" [matTooltipDisabled]="true"
                                                    #tooltip="matTooltip"
                                                    (click)="copyToClipboard(address.userAddress, tooltip)">
                                                    <mat-icon role="img"
                                                        class="mat-icon notranslate material-icons mat-icon-no-color me-1"
                                                        aria-hidden="true"
                                                        data-mat-icon-type="font">content_copy_outlined_icon</mat-icon>
                                                    Copy
                                                </button>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-outline-primary"
                [disabled]="isUserAddressSelected() || isLoading || selectedIndex == dataList.length - 1"
                (click)="skip()">Skip</button>
            <button class="btn btn-primary"
                [disabled]="(!isUserAddressSelected() && selectedAddress !== selected.krollAddress) || isLoading"
                (click)="onContinueAndClose()">
                {{ isLoading ? 'Adding...' : (selectedIndex == dataList.length - 1 ? 'Continue & Close' : 'Continue') }}
            </button>

        </div>
    </div>
</div>
